import { getMonth, getYear, startOfMonth } from 'date-fns';

import { Month } from '../types';

export default function getDateMonthAndYear(date: Date): Month {
  const firstDayInMonthDate = startOfMonth(date);
  const year = getYear(firstDayInMonthDate);
  const month = getMonth(firstDayInMonthDate);

  return {
    year,
    month,
    date: firstDayInMonthDate,
  };
}
